// Styles
import { FormLabelWithIconBox } from '../../styles'


// Utils
import { useTranslation } from 'react-i18next'

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../../../../Context/PermissionsContext';
import { ContractScopeContainer } from '../../../../../../containers/ContractScopeContainer';
import { Grid, Input } from '@mui/material';
import { SelectInput } from '../../../../../SelectInput';
import { CustomFormLabel } from '../../../../../../pages/styles';

export const ExternalRoleWithContract = ({
  data,
  companies,
  selectedCompany,
  handleSetCompany,
  companyContracts,
  errors,
  setErrors,
  form,
  setForm,
  handleChangeStepTwo,
  user,
  isSupervisor
}) => {
  const ability = useAbility(AbilityContext);
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} sx={{ height: '100%', flexDirection: 'column', flexWrap: 'nowrap', minHeight: 0 }}>
      {ability.can("AllCompanies") &&
        <Grid item>
          <Grid item xs={12} mb={1}>
			<FormLabelWithIconBox>
				<CustomFormLabel bold>{t('system.users.table.company')}</CustomFormLabel>
			</FormLabelWithIconBox>
            <SelectInput 
                label={''}
                onChange={(value) => handleSetCompany(value) }
                value={selectedCompany}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option != null ? option.name : ''}
                options={companies.map((obj) => { return obj })}
                keyValue="provider"
                sx={{ width: '25%' }}
                error={errors.company?.message}
                renderInput={(params) => <Input {...params} label={t('system.users.selectCompany')} />}
                disableClearable={true}
                disableCloseOnSelect={false}
            />
          </Grid>
        </Grid>
      }
      <Grid item sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <ContractScopeContainer
          data={data}
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          companyContracts={companyContracts}
          handleChangeStepTwo={handleChangeStepTwo}
          disabled={!selectedCompany?.id}
          user={user}
          isSupervisor={isSupervisor}
        />
      </Grid>
    </Grid>
  )
}
